import React from 'react';
import "./logo-responsive.css";
import "./logo.css"
// import img from "./images/newLogo.jpg"
// import img from "/images/newLogo.jpg";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Logo = ()  => {
    const location = useLocation();
    const navigate = useNavigate();

    const handleClick = (path: string) => {
        if (location.pathname === path) {
            // If the current path is the same as the clicked path, reload the page
            window.location.reload();
        } else {
            // Otherwise, navigate to the new path
            navigate(path);
        }
    };


    return (

        <div className="logo_container">
            <Link to="/" rel="noopener noreferrer" onClick={() => handleClick("/")}>
                <img className="img_" src="/images/newLogo.webp" alt="Logo"/>
            </Link>
        </div>
    )
        ;
};

export default Logo;
